import type { $Fetch } from 'ofetch';
import type { VendaParcela } from '@/domain/model/Venda';
import type { Page } from '@/domain/model/Page';
import type { AdminParcelaGateway, ListAdminParcelasParams } from '@/application/port/out/AdminParcelaGateway';
import type { ApiResponse, SpringPage } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/parcelas';

export class HttpAdminParcelaGateway implements AdminParcelaGateway {
  constructor(private readonly client: $Fetch) {}

  async list(p: ListAdminParcelasParams): Promise<Page<VendaParcela>> {
    const params: Record<string, string | number> = {};
    if (p.status) params['status'] = p.status;
    if (p.vendaId) params['vendaId'] = p.vendaId;
    if (p.alunoId) params['alunoId'] = p.alunoId;
    if (p.vencimentoDe) params['vencimentoDe'] = p.vencimentoDe;
    if (p.vencimentoAte) params['vencimentoAte'] = p.vencimentoAte;
    if (typeof p.page === 'number') params['page'] = p.page;
    if (typeof p.size === 'number') params['size'] = p.size;
    const res = await this.client<ApiResponse<SpringPage<VendaParcela>>>(PATH, { method: 'GET', params });
    assertApiSuccess(res);
    const d = res.data;
    return { content: d.content, number: d.number, size: d.size, totalElements: d.totalElements, totalPages: d.totalPages, first: d.first, last: d.last };
  }
}
